<!--获取云停车场通道信息接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode":"PR2WCYG4"
            },
            responseCode: 	{"data":{"recordList": [{
                        "id": 57,
                        "parkGlobalID": "13c0eab4-e4a5-4a22-a16f-bffc91442a7c",
                        "entranceName": "测试云车场入口1",
                        "ytjSeq": null,
                        "ytjStatus": null,
                        "entranceType": 1,
                        "enable": true,
                        "isSelfOpenGate": 0,
                        "settlementType": 0,
                        "noPlatePassMode": 3,
                        "noChannelMode": 2,
                        "normalCarPassMode": 2,
                        "localVipCarPassMode": 2,
                        "thirdPartyVipCarPassMode": null,
                        "vipNotInPassMode": 2,
                        "blacklistPassMode": null,
                        "redListPassMode": null,
                        "visitorListPassMode": null,
                        "shareListPassMode": 2,
                        "dynamicVipToNormalMode": 2,
                        "parkCode": null,
                        "parkName": null,
                        "voiceOpenPeriod": "00:00-23:59",
                        "qrCodeValue": null,
                        "qrCodeStr": null,
                        "customCode": null,
                        "areaID": null,
                        "isRootChannel": false,
                        "actionType": null,
                        "timeArray": [
                        "00:00",
                        "23:59"
                        ],
                        "deviceVolume": 50,
                        "boxId": null,
                        "displayContent": "{\"displayContentArray\":[[\"%CN\"],[\"%T\"],[],[]]}",
                        "displayViewModel": 0
                    },
                    {
                        "id": 58,
                        "parkGlobalID": "13c0eab4-e4a5-4a22-a16f-bffc91442a7c",
                        "entranceName": "测试云车场出口1",
                        "ytjSeq": null,
                        "ytjStatus": null,
                        "entranceType": 2,
                        "enable": false,
                        "isSelfOpenGate": 0,
                        "settlementType": 0,
                        "noPlatePassMode": 3,
                        "noChannelMode": 2,
                        "normalCarPassMode": 2,
                        "localVipCarPassMode": 2,
                        "thirdPartyVipCarPassMode": null,
                        "vipNotInPassMode": 2,
                        "blacklistPassMode": null,
                        "redListPassMode": null,
                        "visitorListPassMode": null,
                        "shareListPassMode": 2,
                        "dynamicVipToNormalMode": 2,
                        "parkCode": null,
                        "parkName": null,
                        "voiceOpenPeriod": "00:00-23:59",
                        "qrCodeValue": null,
                        "qrCodeStr": null,
                        "customCode": null,
                        "areaID": null,
                        "isRootChannel": false,
                        "actionType": null,
                        "timeArray": [
                        "00:00",
                        "23:59"
                        ],
                        "deviceVolume": 50,
                        "boxId": null,
                        "displayContent": "{\"displayContentArray\":[[\"%CN\"],[\"%T\"],[],[]]}",
                        "displayViewModel": 0
                    }]},"message":"业务成功","resultCode":0,"status":1},
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台获取云停车场通道信息",
                t_url: this.commonUrls.test+"getChannelInfo",
                p_url: this.commonUrls.prod+"getChannelInfo",
                precondition: "",
                fitSystem: "云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'recordList', info2: '是', info3: 'JSONArray', info4: '通道信息列表' }
                        ]
                },{
                    titleName: 'recordList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'id', info2: '是', info3: 'String', info4: '通道id' },
                        { info1: 'parkGlobalID', info2: '否', info3: 'String', info4: '停车场主键编号' },
                        { info1: 'entranceName', info2: '是', info3: 'Integer', info4: '通道名称' },
                        { info1: 'ytjSeq', info2: '是', info3: 'Integer', info4: '关联的一体机自增ID' },
                        { info1: 'ytjStatus', info2: '是', info3: 'Integer', info4: '关联的一体机状态,没有关联的一体机则是NULL' },
                        { info1: 'entranceType', info2: '是', info3: 'Integer', info4: '通道类型 描述信息查询字典表进出口类型（0：未确认，1：进口，2：出口) 去除进出口类型' },
                        { info1: 'enable', info2: '否', info3: 'Integer', info4: '通道状态 启用禁用' },
                        { info1: 'isSelfOpenGate', info2: '是', info3: 'Decimal', info4: '是否自助开闸 0否 1是' },
                        { info1: 'settlementType', info2: '是', info3: 'Decimal', info4: '结算类型（0非结算通道，1实时结算通道，2延时结算通道）' },
                        { info1: 'noPlatePassMode', info2: '是', info3: 'Decimal', info4: '无牌车通行模式（0未定义，1严 手动验证放行，2宽 自动验证放行,3自助进出）' },
                        { info1: 'noChannelMode', info2: '是', info3: 'Decimal', info4: '无通道权限放行模式，0未设定，1手动验证放行，2自动验证放行' },
                        { info1: 'normalCarPassMode', info2: '是', info3: 'Decimal', info4: '临时车放行模式，0未设定，1手动验证放行，2自动验证放行' },
                        { info1: 'localVipCarPassMode', info2: '是', info3: 'Decimal', info4: '本地VIP车辆进场模式，0未设置，1手动确认放行，2自动确认放行' },
                        { info1: 'thirdPartyVipCarPassMode', info2: '是', info3: 'Decimal', info4: '第三方VIP车辆进场模式，0未设置，1手动确认放行，2自动确认放行' },
                        { info1: 'vipNotInPassMode', info2: '是', info3: 'Decimal', info4: 'vip无在场放行模式，0未设定，1手动验证放行，2自动验证放行' },
                        { info1: 'blacklistPassMode', info2: '是', info3: 'Decimal', info4: '黑名单通行模式，0未设定，1手动验证放行，2自动验证放行' },
                        { info1: 'redListPassMode', info2: '是', info3: 'Decimal', info4: '红名单通行模式，0未设定，1手动验证放行，2自动验证放行' },
                        { info1: 'visitorListPassMode', info2: '是', info3: 'Decimal', info4: '访客通行模式，0未设定，1手动验证放行，2自动验证放行' },
                        { info1: 'shareListPassMode', info2: '是', info3: 'Decimal', info4: '共享车辆放行模式，0未设定，1手动验证放行，2自动验证放行' },
                        { info1: 'dynamicVipToNormalMode', info2: '是', info3: 'Decimal', info4: '多位多车转VIP转临时车放行模式，0未设定，1手动验证放行，2自动验证放行；描述信息查询字典表' },
                        { info1: 'parkCode', info2: '是', info3: 'Decimal', info4: '停车场编号,VIP服务需要' },
                        { info1: 'parkName', info2: '是', info3: 'Decimal', info4: '停车场名称' },
                        { info1: 'voiceOpenPeriod', info2: '是', info3: 'Decimal', info4: '语音开启时间段00:00-24:00' },
                        { info1: 'qrCodeValue', info2: '是', info3: 'Decimal', info4: '二维码的实际URL' },
                        { info1: 'qrCodeStr', info2: '是', info3: 'Decimal', info4: '二维码Base64' },
                        { info1: 'customCode', info2: '是', info3: 'Decimal', info4: '自定义通道编码' },
                        { info1: 'areaID', info2: '是', info3: 'Decimal', info4: '所属根区域ID' },
                        { info1: 'isRootChannel', info2: '是', info3: 'Decimal', info4: '是否是根区域绑定的通道' },
                        { info1: 'actionType', info2: '是', info3: 'Decimal', info4: '动作类型 新增0修改1删除2 这里必须要填个值' },
                        { info1: 'timeArray', info2: '是', info3: 'Decimal', info4: '时段数组 下标0是开始 下标1结束时间' },
                        { info1: 'deviceVolume', info2: '是', info3: 'Decimal', info4: '设备音量 0-100 默认50' },
                        { info1: 'boxId', info2: '是', info3: 'Decimal', info4: '关联的盒子自增ID' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/park/getChannelInfo.vue